import React, { useState } from 'react';
import { Form, Input, Button, Typography, Alert, notification, Radio } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { NavLink, useNavigate } from 'react-router-dom';
import authService from 'services/auth.services';
import RegisterCheckBox from './RegisterCheckBox';
import AgreementModal from './AgreementModal';

// Enum tanımı
const IdentityNumberType = {
  VKN: 'VKN',
  TCKN: 'TCKN',
};

const Register = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const checkNumber = (rule, value) => {
    if (!value || !value.trim()) {
      return Promise.reject(new Error('Zorunlu Alan'));
    }
    if (value.length === 10 || value.length === 11) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('Kimlik Numarası 10 veya 11 haneli olmalıdır.'));
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setIsLoading(true);

      // identityNumberList'i doğru formata dönüştür
      const formattedIdentityNumberList = values.identityNumberList.map((item) => ({
        type: item.type, // Type alanını Enum'dan alıyoruz
        number: item.number, // Number alanını olduğu gibi alıyoruz
      }));

      const body = {
        email: values.email,
        identityNumberList: formattedIdentityNumberList, // Düzenlenmiş listeyi ekliyoruz
        userAgreement: values.userAgreement || false,
      };

      await authService.register(body);
      setIsLoading(false);
      notification.success({
        message: 'İşlem Başarılı',
        description: 'Lütfen mailinize gelen yönergeleri takip ediniz.',
      });
      navigate('/login');
    } catch (err) {
      setIsLoading(false);
      setError(err.message || 'Bir hata oluştu.');
      notification.error({
        message: 'İşlem Başarısız',
        description: err.message || 'Bir hata oluştu.',
      });
    }
  };

  const handleOk = () => {
    setIsModalVisible(false);
    form.setFieldsValue({
      userAgreement: true,
    });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.setFieldsValue({
      userAgreement: false,
    });
  };

  return (
    <div className="register-page flex-row align-items-center">
      <div className="register-card">
        <div className="register-form-wrapper">
          <Form form={form} onFinish={handleSubmit} layout="vertical">
            <Typography.Title level={4} className="register-title">
              <NavLink to="/login">
                <span className="back-icon">
                  <ArrowLeftOutlined />
                </span>
              </NavLink>
              Paye Kart Kayıt Formu
            </Typography.Title>
            <Form.Item
              name="email"
              label="E-Posta"
              rules={[
                { required: true, message: 'Zorunlu Alan' },
                { type: 'email', message: 'Geçersiz mail adresi!' },
              ]}
            >
              <Input className="input__default" placeholder="E-Posta" />
            </Form.Item>
            <Form.List
              name="identityNumberList"
              initialValue={[{ type: IdentityNumberType.VKN, number: '' }]} // Varsayılan değer
            >
              {(fields, { add }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <div key={key} className="identity-number-item">
                      <Form.Item
                        {...restField}
                        name={[name, 'type']}
                        label="Kimlik Tipi"
                        rules={[{ required: true, message: 'Zorunlu Alan' }]}
                      >
                        <Radio.Group>
                          <Radio value={IdentityNumberType.VKN}>VKN</Radio>
                          <Radio value={IdentityNumberType.TCKN}>TCKN</Radio>
                        </Radio.Group>
                      </Form.Item>
                      <Form.Item
                        {...restField}
                        name={[name, 'number']}
                        label="Kimlik Numarası"
                        rules={[
                          { required: true, message: 'Zorunlu Alan' },
                          { validator: checkNumber },
                        ]}
                      >
                        <Input placeholder="Kimlik Numarası" />
                      </Form.Item>
                    </div>
                  ))}
                  <Form.Item>
                    <Button
                      type="dashed"
                      onClick={() => add({ type: IdentityNumberType.VKN, number: '' })}
                    >
                      Yeni Kimlik Bilgisi Ekle
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
            <Form.Item name="userAgreement" valuePropName="checked" initialValue={false}>
              <RegisterCheckBox
                onClick={() => {
                  setIsModalVisible(true);
                }}
              />
            </Form.Item>
            {error && (
              <Form.Item>
                <Alert message={error} type="error" showIcon />
              </Form.Item>
            )}
            <Form.Item className="float-right">
              <Button
                className="button button__fill"
                type="primary"
                htmlType="submit"
                disabled={isLoading}
                loading={isLoading}
              >
                GÖNDER
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>

      <AgreementModal
        isModalVisible={isModalVisible}
        handleOk={handleOk}
        handleCancel={handleCancel}
      />
    </div>
  );
};

export default Register;